// Plausible custom events ("goals"). The Plausible script only loads in production
// (layouts/application.html.erb), so in dev this does nothing. Each event name also
// has to be added as a goal in the Plausible dashboard before it shows up there.
// Never put what the visitor typed (addresses, txids, invoices) in props.

type GoalProps = Record<string, string | number | boolean>

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: GoalProps }) => void
  }
}

export const trackGoal = (event: string, props?: GoalProps) => {
  try {
    if (typeof window === "undefined" || typeof window.plausible !== "function") return
    window.plausible(event, props ? { props } : undefined)
  } catch (_e) {
    // analytics must never break a tool
  }
}
